import type { Leave } from '@lms/shared-types'

/**
 * Requester-side cancellation rules — kept in one place so every self-serve
 * surface (leave detail page, My Leave history list) agrees with the API.
 *
 * An already-APPROVED leave cannot be voided one-click: the requester files a
 * cancellation request (`POST /leaves/{id}/request-cancellation`) that their
 * manager approves or rejects. The api gate lives in
 * `request_leave_cancellation_tx` (services/api/src/domain/leave_decisions.py).
 */

/** Minimum reason length the api requires to request an approved-leave cancellation. */
export const CANCEL_REQUEST_REASON_MIN = 5

/**
 * True when the requester can ask to cancel a leave: only an already-APPROVED
 * leave routes through the manager-approval flow. (Pending / escalated leaves
 * are withdrawn directly via the plain cancel button, not this flow.)
 */
export function canRequestCancellation(
  leave: Pick<Leave, 'status'>,
): boolean {
  return leave.status === 'approved'
}
